type ReactPaginateModuleShape<TComponent> = {
  default?: TComponent;
};

function isReactPaginateComponent<TComponent>(
  value: unknown,
): value is TComponent {
  return typeof value === "function";
}

function hasNestedDefault<TComponent>(
  value: unknown,
): value is ReactPaginateModuleShape<TComponent> {
  return typeof value === "object" && value !== null && "default" in value;
}

// During the Vite 8 Rolldown transition, react-paginate can resolve through a
// nested default export in dev/HMR. Keep the interop fix isolated here until
// that upstream/module shape stabilizes.
export function resolveReactPaginate<TComponent>(
  moduleDefault: unknown,
): TComponent {
  if (isReactPaginateComponent<TComponent>(moduleDefault)) {
    return moduleDefault;
  }

  if (hasNestedDefault<TComponent>(moduleDefault)) {
    const nestedDefault = moduleDefault.default;

    if (isReactPaginateComponent<TComponent>(nestedDefault)) {
      return nestedDefault;
    }
  }

  throw new Error("react-paginate did not export a renderable component");
}
